module.exports = __webpack_public_path__ + "img/sbadge_g.bb918241.svg";